import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { getManagerCardLift } from "../../components/ui/cardStyles.js";
import { useAllSims } from "../../logic/hooks/useAllSims.js";
import { SimManager } from "./SimManager.jsx";

export function SimsPage() {
  const simState = useAllSims();
  const { c, dark } = useThemeSlice();

  const cardLift = getManagerCardLift(dark);

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: "14px" }}>
      <div style={{ background: c.card, border: `1px solid ${c.cardBdr}`, borderRadius: 12, flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: cardLift }}>
        <SimManager
          {...simState}
          emptyHint="Create a SIM card and assign a plan type to track connectivity inventory."
        />
      </div>
    </div>
  );
}
